<template>
  <div class="dropdown-pdf-container">
    <div class="question-title-pdf" style="font-weight: bold; font-size: 14px; padding-bottom: 8px">
      Câu {{ question.index + 1 }}:
    </div>
    <div v-if="dropdownQuestions.length > 0" class="mb-2 mt-2">
      <div class="font-weight-medium mb-1" style="font-size: 14px; font-weight: bold">Danh sách câu hỏi:</div>
      <div style="padding-left: 8px">
        <div
          v-for="(qItem, idx) in dropdownQuestions"
          :key="qItem.id || idx"
          style="margin-bottom: 6px; display: block"
        >
          <span style="font-weight: bold; margin-right: 8px; vertical-align: top">{{ qItem.index + 1 }}.</span>

          <div style="display: inline-block; vertical-align: top; width: calc(100% - 40px)">
            <div style="display: inline-block" v-html="formatInlineHtml(qItem.html)"></div>

            <template v-if="!isQuestionPaper && !submission.isStudentWork">
              <span class="ml-2 d-inline-flex align-center">
                <span
                  :style="{
                    color: getChildResult(qItem.id).isCorrect ? '#4bca81' : '#d4504c',
                    fontWeight: 'bold',
                    fontSize: '14px',
                  }"
                >
                  [{{ getChildResult(qItem.id).studentLabel }}]
                  <span
                    style="margin-left: 2px"
                    v-html="getChildResult(qItem.id).isCorrect ? '&#10003;' : '&#10005;'"
                  ></span>
                </span>
              </span>
            </template>

            <!-- Nếu là bài làm HS, chỉ hiện nhãn của HS chọn thôi -->
            <template v-else-if="submission.isStudentWork">
              <span class="ml-2" style="font-weight: bold; color: #000">
                [{{ getChildResult(qItem.id).studentLabel }}]
              </span>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div v-if="optionsPool.length > 0" class="mb-2 mt-2">
      <div class="font-weight-medium mb-1" style="font-size: 14px; font-weight: bold">Danh sách lựa chọn:</div>

      <div style="display: block; width: 100%; padding-left: 8px">
        <div
          v-for="opt in optionsPool"
          :key="opt.key"
          style="display: inline-block; margin-right: 25px; margin-bottom: 5px; vertical-align: top"
        >
          <span style="margin-right: 4px">{{ opt.label }}.</span>

          <div style="display: inline-block" v-html="formatInlineHtml(opt.value)"></div>
        </div>
      </div>

      <v-divider class="my-2" style="opacity: 0.3" v-if="!isQuestionPaper" />
    </div>

    <!-- <div class="caption mt-1" v-if="!isQuestionPaper">
      <div>
        <span class="font-weight-medium">Trả lời: </span>
        <span :style="{color: isCorrect ? '#4bca81' : '#d4504c'}" v-html="displayAnswer"></span>
        <v-icon v-if="isCorrect" color="green" small class="ml-1">mdi-check-circle</v-icon>
        <v-icon v-else color="red" small class="ml-1">mdi-close-circle</v-icon>
      </div>
    </div> -->
  </div>
</template>

<script>
import get from 'lodash-es/get'
import {mapGetters} from 'vuex'

export default {
  props: {question: Object, isQuestionPaper: Boolean, submission: Object},
  computed: {
    ...mapGetters({
      allQuestions: 'pdfRender/getQuestions',
    }),

    parentGroup() {
      if (this.question.type.includes('group')) return this.question
      const questionsToSearch = this.allQuestions || []
      return questionsToSearch.find(
        q =>
          q.questions &&
          q.questions.some(childId => {
            const id = typeof childId === 'object' ? childId.id : childId
            return id === this.question.id
          })
      )
    },

    dropdownQuestions() {
      const group = this.parentGroup || (this.question.questions ? this.question : null)
      if (!group || !group.questions) return []

      return group.questions
        .map(child => {
          if (typeof child === 'object' && child.html) return child
          const childId = typeof child === 'object' ? child.id : child
          return this.allQuestions.find(q => q.id === childId) || {html: ''}
        })
        .filter(q => q.html)
    },

    displayHtml() {
      let html = this.question.html || ''
      if (!html) return ''
      return this.formatQuestionHtml(html)
    },

    optionsPool() {
      const poolSource = this.parentGroup?.answers || this.question.answers
      if (!poolSource) return []

      const answers = Array.isArray(poolSource) ? poolSource : Object.values(poolSource)
      return answers
        .map(a => ({
          key: a.key,
          label: a.label,
          value: a.value,
        }))
        .sort((a, b) => (a.label || '').localeCompare(b.label || ''))
    },

    answerData() {
      return get(this.submission, `answers.${this.question.id}`, {})
    },
    isCorrect() {
      return this.answerData.isCorrect || false
    },
    displayAnswer() {
      const val = this.answerData.answer || this.answerData.answerId
      if (!val) return '...'
      const found = this.optionsPool.find(a => a.key === val)
      if (found) return `${found.label}. ${this.stripHtml(found.value)}`
      return val
    },
  },
  methods: {
    formatInlineHtml(html) {
      if (!html) return ''
      return html
        .replace(/<p/g, '<span style="display:inline;margin:0;padding:0;"')
        .replace(/<\/p>/g, '</span>')
        .replace(/<div/g, '<span style="display:inline;margin:0;padding:0;"')
        .replace(/<\/div>/g, '</span>')
    },

    stripHtml(html) {
      if (!html) return ''
      const doc = new DOMParser().parseFromString(html, 'text/html')
      return (doc.body.textContent || doc.body.innerText || '').trim()
    },
    getChildResult(childId) {
      const answerData = get(this.submission, `answers.${childId}`, {})
      const studentKey = answerData.answer || answerData.answerId
      const foundStudent = this.optionsPool.find(a => a.key === studentKey)

      return {
        isCorrect: answerData.isCorrect || false,
        studentLabel: foundStudent ? foundStudent.label : studentKey ? '?' : '___',
      }
    },
  },
}
</script>
